import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const BusinessMatchSchema = z
    .object({
        name: z.number(),
        address: z.number(),
    })
    .strict();

export class BusinessMatch extends FromSchema(BusinessMatchSchema) {
    name: number;
    address: number;
}
